module.exports = __webpack_public_path__ + "static/img/HN.f73fe2ce.png";